import { ROUTE_FOR_ASSETS, ROUTES_FOR_KAZAKH_ASSETS } from "../constants/routes"

export const getAssetUrl = (url= '') => {
    if (url.includes('/uploads')) {
        return `${ROUTES_FOR_KAZAKH_ASSETS}${url}`
    }

    return `${ROUTE_FOR_ASSETS}/api/v1/cms-loyalty/api/bonuses/packages/file/${url}`
}